module.exports = __webpack_public_path__ + "media/customizations/collective/logo-new-3eecf1849a427ef02a2cc580d797b415.png";